
import { PermissionString } from '../../constants/permissions';
import { useHasPermission, useHasViewPermission, useUserGroup } from '../../hooks';
import { useGroupsQuery } from '../../queries';
import { UserService } from '../../services';
import { CUSTOMER, INTERNAL } from '../settings/AccessPolicies/constants';

interface Props {
  children: any;
}

export const isInternal = async (): Promise<boolean> => {
  const response = await UserService.isInternal();
  return response;
};

export function InternalOnly(props: Props) {
  const { data: groupsFromQuery } = useGroupsQuery();
  const groups = groupsFromQuery || [];

  const internalRoles = groups.filter((group) => group.scope === INTERNAL);
  const userGroupName = useUserGroup();

  const hasAccess = internalRoles.some((group) => group.name === userGroupName);

  if (hasAccess) {
    return props.children;
  }

  return null;
}

export function CustomerOnly(props: Props) {
  const { data: groupsFromQuery } = useGroupsQuery();
  const groups = groupsFromQuery || [];
  const customerRoles = groups.filter((group) => group.scope === CUSTOMER);

  const userGroupName = useUserGroup();
  const hasAccess = customerRoles.some((group) => group.name === userGroupName);

  if (hasAccess) {
    return props.children;
  }
  return null;
}

export function AdminOnly(props: Props) {
  const userGroup = useUserGroup();
  const hasAccess = userGroup === 'admin';

  if (hasAccess) {
    return props.children;
  }
  return null;
}

interface SinglePermissionProps {
  children: any;
  permission: PermissionString;
}

interface MultiplePermissionProps {
  children: any;
  permission: PermissionString[];
  all?: boolean;
}

type PermissionProps = SinglePermissionProps | MultiplePermissionProps;

export function Permission(props: PermissionProps) {
  const hasAccess = useHasViewPermission(props.permission);
  const hasAccessToAllPermissions = useHasPermission(props.permission);

  // Handle case when we require ALL of the permissions
  if (props.all) {
    if (hasAccessToAllPermissions) {
      return props.children;
    }
    return null;
  }

  // Default case when we require ANY of the permissions
  if (hasAccess) {
    return props.children;
  }
  return null;
}
